<template functional>
  <span class="dataset-cell-date-short">
    {{ $options.format(props) }}
  </span>
</template>

<script>
import { DateTime } from 'luxon'
import ModuleBase from './module-base'

export default {
  name: 'DatasetDateShort',
  mixins: [ModuleBase],
  format: props => {
    const Timezone = props.store && props.store.state.user ? props.store.state.user.me.Timezone : 'utc'
    return DateTime.fromISO(props.value, { setZone: true })
      .setZone(Timezone)
      .toLocaleString(props.column.format_data.format || DateTime.DATE_SHORT)
  },
}
</script>

<style lang="scss">
@import '@/style/inject';

.dataset-cell-date-short {
  // color: $beige;
  font-weight: $weight-medium;
}
</style>